import { defineStore } from 'pinia';

import {
  AccountRegisterResponse,
  AccountRepository,
  AcquirerResponse,
  CompanyResponse,
  IssuerResponse,
  ShopResponse,
  WalletServiceResponse,
} from '@/repositories/generated';
import { DeepPartial } from '@/types';
import { AccountRegisterForm } from '@/validations';

type TAccountState = {
  form: AccountRegisterForm | undefined;
  initData: DeepPartial<AccountRegisterForm> | undefined;
  response: AccountRegisterResponse;
  selectedAcquirerName: AcquirerResponse | undefined;
  selectedIssuerName: IssuerResponse | undefined;
  selectedWalletServiceName: WalletServiceResponse | undefined;
  selectedCompanyName: CompanyResponse | undefined;
  selectedShopName: ShopResponse | undefined;
};

export const useAccountStore = defineStore('registAccount', {
  state: (): TAccountState => ({
    form: undefined,
    initData: undefined,
    response: {} as AccountRegisterResponse,
    selectedAcquirerName: undefined,
    selectedIssuerName: undefined,
    selectedWalletServiceName: undefined,
    selectedCompanyName: undefined,
    selectedShopName: undefined,
  }),
  actions: {
    async register(): Promise<AccountRegisterResponse> {
      const { form } = this;

      if (!form) return {} as AccountRegisterResponse;

      this.response = await AccountRepository.register({
        requestBody: {
          ...form,
          acquirerId: form.acquirerId,
          companyId: form.companyId,
          email: form.email,
          issuerId: form.issuerId,
          loginId: form.loginId,
          name: form.name,
          remarks: form.remarks,
          role: form.role,
          shopId: form.shopId,
          walletServiceId: form.walletServiceId,
        },
      });

      return this.response;
    },
    setForm(form: AccountRegisterForm) {
      const createFrom = (_form: AccountRegisterForm) => ({
        ..._form,
      });
      this.form = createFrom(form);
      this.initData = createFrom(form);
    },
  },
});
